import '../../atoms/textarea/TextArea';
import '../../atoms/char-count/CharCount';
import TextArea, { type TextAreaProps } from '../../atoms/textarea/TextArea';
import type { CharCountProps } from '../../atoms/char-count/CharCount';
import './TextAreaCharCount.pcss';

export type TextAreaCharCountProps = {
    input: TextAreaProps;
    charCount: CharCountProps;
};

export default class TextAreaCharCount extends HTMLElement {
    readonly #textareaElement: TextArea | null | undefined;

    #textAreaEvents = ['focus', 'blur'];

    constructor(props: TextAreaCharCountProps) {
        super();

        const elementSelector = props?.charCount.elementSelector ?? this.dataset.elementSelector;
        if (!elementSelector) {
            // eslint-disable-next-line no-console
            console.warn(`TextAreaCharCount: elementSelector not specified.`);
            return;
        }

        this.#textareaElement = <TextArea>this.querySelector(elementSelector);

        if (!this.#textareaElement) {
            // eslint-disable-next-line no-console
            console.warn(`TextAreaCharCount: textareaElement not found`);
        }
    }

    protected connectedCallback(): void {
        this.addEventListener('click', this.#focusOnTextarea.bind(this));

        this.#textAreaEvents.forEach((event) => {
            this.#textareaElement?.addEventListener(event, this.#toggleFocus.bind(this));
        });
    }

    protected disconnectedCallback(): void {
        this.removeEventListener('click', this.#focusOnTextarea.bind(this));

        this.#textAreaEvents.forEach((event) => {
            this.#textareaElement?.removeEventListener(event, this.#toggleFocus.bind(this));
        });
    }

    protected attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (oldValue === newValue) {
            return;
        }

        this.#textareaElement?.setAttribute(name, newValue);
    }

    #focusOnTextarea(): void {
        this.#textareaElement?.focus();
    }

    #toggleFocus(): void {
        if (!this.#textareaElement?.isDisabled) {
            this.classList.toggle('focus');
        }
    }
}

if (!window.customElements.get('nh-text-area-charcount')) {
    window.customElements.define('nh-text-area-charcount', TextAreaCharCount);
}
